(() => {
  const successDialog = /** @type {HTMLDialogElement | null} */ (
    document.getElementById('vv-signup-success-modal')
  );
  if (!successDialog) return;

  const SUCCESS_HASH = '#vv-signup-success';

  /** @type {number} */
  let previousScrollY = 0;

  const isLocalThemeDev = () => {
    const host = window.location.hostname;
    return host === '127.0.0.1' || host === 'localhost';
  };

  const unlockScroll = () => {
    document.body.style.width = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.documentElement.classList.remove('vv-signup-modal-open');
    window.scrollTo({ top: previousScrollY, behavior: 'instant' });
  };

  const closeLandingOverlay = () => {
    const landingOverlay = document.querySelector('[data-vv-landing-waitlist-modal]');
    if (!landingOverlay) return;
    landingOverlay.classList.remove('is-open');
    landingOverlay.hidden = true;
  };

  const openSuccessModal = () => {
    if (successDialog.open) return;

    closeLandingOverlay();
    previousScrollY = window.scrollY;

    requestAnimationFrame(() => {
      document.body.style.width = '100%';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${previousScrollY}px`;
      document.documentElement.classList.add('vv-signup-modal-open');
      successDialog.showModal();
    });
  };

  const closeSuccessModal = () => {
    if (!successDialog.open) return;
    successDialog.close();
    unlockScroll();
  };

  const cleanSuccessFromUrl = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete('vv_signup_success');

    const query = params.toString();
    const nextUrl = `${window.location.pathname}${query ? `?${query}` : ''}`;
    window.history.replaceState({}, '', nextUrl);
  };

  successDialog.addEventListener('click', (event) => {
    if (event.target === successDialog) closeSuccessModal();
  });

  successDialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeSuccessModal();
  });

  successDialog.addEventListener('close', () => {
    if (document.documentElement.classList.contains('vv-signup-modal-open')) {
      unlockScroll();
    }
  });

  document.querySelectorAll('[data-vv-signup-close]').forEach((button) => {
    button.addEventListener('click', closeSuccessModal);
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.classList.contains('vv-email-signup-form')) return;
      if (!isLocalThemeDev()) return;

      event.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      openSuccessModal();
    },
    true
  );

  const params = new URLSearchParams(window.location.search);
  const hasLegacySuccessParam = params.has('vv_signup_success');
  const hasSuccessHash = window.location.hash === SUCCESS_HASH;

  if (!hasLegacySuccessParam && !hasSuccessHash) return;

  openSuccessModal();
  cleanSuccessFromUrl();
})();
